import React, { useEffect, useState, Fragment } from 'react'
import styled from 'styled-components'
import {
  Typography,   
  CircularProgress,
  Table,
  TableHead, 
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Checkbox,
} from '@material-ui/core'
import BarChartStacked from '../charts/BarChartStacked'
import { HowToReg } from '@material-ui/icons'
import Cookies from 'js-cookie'
import AskReport from '../AskReport'
import PageHeader from '../PageHeader'

const StyledTableRow = styled(TableRow)(({theme}) => ({
  '&:last-child td, &:last-child th': {
    border: 0,
  }
}))

const RfmCounts = (props) => {
  const {dark} = props
  const token = Cookies.get("token")
  const [metric, setMetric] = useState("location")
  const [rfmData, setRfmData] = useState(null)
  const [defaultRfmData, setDefaultRfmData] = useState(null)
  const [rfmTotal, setRfmTotal] = useState(null)
  const [filters, setFilters] = useState({otb: 1, trade: 1})
  const [rfmChecked, setRfmChecked] = useState([])
  const [checkList, setCheckList] = useState([])
  
  const getRfmData = () => {    
    const request = Promise.all([
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/rfm/${metric}`, {headers: {token: token}}),
      fetch(`${[process.env.REACT_APP_BASE_URL_DEV]}/rfm`, {headers: {token: token}})
    ])

    request.then(([response, response2]) => Promise.all([response.json(), response2.json()]))
    .then(([data, data2]) => {      
      setRfmData(data)
      setDefaultRfmData(data)
      setRfmTotal(data.map(({Data}) => Data.map(({COUNT_ALL}) => COUNT_ALL).reduce((a,b) => a + b, 0)).reduce((a,b) => a + b, 0))
      setRfmChecked(data.map(({Data}) => Data.map(({RFM_Segment}) => RFM_Segment))[0])
      setCheckList(data[0].Data)
    })
    .catch(error => console.log(error))
  }
  
  useEffect(() => getRfmData(), [])
  
  const getSeries = (data) => {
    const series = []
    const colorsHash = {
      0: "#27f289",
      1: "#9cecff",
      2: "#ce82fa",
      3: "#dfb0ff",
      4: "#ebd63f",
      5: "#f5bc49",
      6: "#e38fb6",
      7: "#f7850a",
      8: "#ff2b34",
      9: "#dbd6c8",
      10: "#d1c5c5",
      11: "#bfaea4",
      12: "#9c9981"
    }

    const dataHash = {
      "11": "COUNT_ALL",
      "10": "COUNT_TA",
      "01": "NOOTB_ALL",
      "00": "NOOTB_TA"
    }    

    let rfmLength = data.map(({Data}) => Data.length)[0]    

    for(let i = 0; i < rfmLength; i++) {      
      let obj = {}
      obj["name"] = data.map(({Data}) => Data[i].RFM_Segment)[0]
      obj["order"] = data.map(({Data}) => Data[i].RFM_Ord)[0]
      obj["data"] = data.map(({Data}) => Data[i][dataHash[Object.values(filters).join("")]])      
      obj["color"] = colorsHash[obj.order] ? colorsHash[obj.order] : ""

      series.push(obj)
    }
    
    return series
  }

  const handleMetricChange = (e) => {
    const { value } = e.target    
    const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/rfm/${value}`, {headers: {token: token}})

    request.then((response => response.json()))
    .then(data => {
      let filteredData = []
      for(let i = 0; i < data.length; i++) {
        let dataObj = {}
        dataObj["Key"] = data[i].Key
        dataObj["Label"] = data[i].Label
        dataObj["Data"] = []
        for(let j = 0; j < data[i].Data.length; j++) {
          if(rfmChecked.indexOf(data[i].Data[j].RFM_Segment) !== -1) dataObj["Data"].push(data[i].Data[j])
        }
        filteredData.push(dataObj)        
      }
      setRfmData(filteredData)
      setDefaultRfmData(data)
      setMetric(value)
    })
  }

  const handleFilterChange = (e) => {
    const { value, name } = e.target
        
    setFilters(prevState => ({...prevState, [name]: value}))
  }

  const handleRfmChange = (e) => {
    const { value } = e.target    
    
    if(value.indexOf("All Segments") !== -1) {      
      if(value.length <= checkList.length) {
        setRfmChecked(defaultRfmData[0].Data.map(({RFM_Segment}) => RFM_Segment))
        setRfmData(defaultRfmData)
      } else {
        setRfmChecked([])
        setRfmData([])
      }
    } else if(value.length <= rfmChecked.length) {      
      let filteredData = []    
      const filterValue = rfmData[0].Data.filter(({RFM_Segment}) => value.indexOf(RFM_Segment) === -1)[0].RFM_Segment
      
      for(let i = 0; i < rfmData.length; i++) {
        let dataObj = {}
        dataObj["Key"] = rfmData[i].Key
        dataObj["Label"] = rfmData[i].Label        
        dataObj["Data"] = []        
        for(let j = 0; j < rfmData[i].Data.length; j++) {          
          if(rfmData[i].Data[j].RFM_Segment !== filterValue) {            
            dataObj["Data"].push(rfmData[i].Data[j])
          }
        }        
        filteredData.push(dataObj)
      }
      
      setRfmData(filteredData)
      setRfmChecked(value)
    } else {      
      let filteredData = [...rfmData]
      
      if(filteredData.length >= 1) {
        let filterValue = value[value.length - 1]
        for(let i = 0; i < defaultRfmData.length; i++) {
          for(let j = 0; j < defaultRfmData[i].Data.length; j++) {          
            if(defaultRfmData[i].Data[j].RFM_Segment === filterValue) {            
              filteredData[i].Data.splice(defaultRfmData[i].Data[j].RFM_Ord, 0, defaultRfmData[i].Data[j])            
            }
          }        
        }
      } else {
        let filterValue = value[0]
        for(let i = 0; i < defaultRfmData.length; i++) {
          let dataObj = {}
          dataObj["Key"] = defaultRfmData[i].Key
          dataObj["Label"] = defaultRfmData[i].Label
          dataObj["Data"] = []          
          for(let j = 0; j < defaultRfmData[i].Data.length; j++) {
            if(defaultRfmData[i].Data[j].RFM_Segment === filterValue) dataObj["Data"].push(defaultRfmData[i].Data[j])
          }
          filteredData.push(dataObj)
        }        
      }

      setRfmData(filteredData)
      setRfmChecked(value)
    }
  }
  
  if(!rfmData) return <CircularProgress />
  
  const renderRfmSelect = (handleChange, checkList, checked) => {        
    
    return (
      <FormControl variant="outlined" className="rfm-segments-select" size="small">
        <InputLabel id={dark ? "rfm-select" : "rfm-select-lt"}>RFM SEGMENTS</InputLabel>
        <Select
          multiple
          labelId="rfm-select"          
          label="RFM SEGMENTS"
          value={checked}
          onChange={handleChange}
          MenuProps={{
            anchorOrigin: {vertical: "bottom", horizontal: "left"},
            transformOrigin: {vertical: "top", horizontal: "left"},
            getContentAnchorEl: null
          }}
          renderValue={selected => (
            selected.length > 1 ?
              <Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{selected.length === checkList.length ? "ALL SEGMENTS" : `${selected.length} SEGMENTS SELECTED`}</Typography>
            :
            selected.map(value => (
              <Typography key={value} variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{value}</Typography>
            ))
          )}
        >
          <MenuItem value={"All Segments"}>
            <Typography variant="caption">{checked.length < checkList.length ? "Select" : "Deselect"} All Segments</Typography>            
          </MenuItem>          
          {checkList.map(({RFM_Segment, RFM_Name, RFM_Ord}, i) => (          
            <MenuItem key={`${RFM_Ord}-${i}`} value={RFM_Segment}>
              <Checkbox 
                checked={rfmChecked.includes(RFM_Segment)}                      
                size="small"
                disableRipple
              />
              <Typography variant="caption">{RFM_Segment + " - " + RFM_Name}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }
  
  return (
    <div id="rfm">      
      <PageHeader 
        details={{title: "RFM COUNTS", icon: <HowToReg style={{fontSize: "16px"}} />}}
      />
      <br/>
      <div style={{display: "flex", justifyContent: "space-between"}}>
        <Paper className={`chart ${dark ? "bg-dk" : "bg-lt"}`}>
          {renderRfmSelect(handleRfmChange, checkList, rfmChecked)}
          <BarChartStacked
            labels={rfmData.map(({Label}) => Label)}
            series={getSeries(rfmData)}
            colors={getSeries(rfmData).map(({color}) => color)}
            xLabel={"RFM Count"}
            darkMode={dark}
            title={"RFM Count by Location"}
          />
        </Paper>
        <div className="filter-table-group">
          <Paper className={`filter-paper ${dark ? "bg-dk" : "bg-lt"}`}>
            <FormControl variant="outlined" className="form-control" size="small">
              <InputLabel id={dark ? "metric-select" : "metric-select-lt"}>METRIC TYPE</InputLabel>
              <Select
                id="metric"
                labelId="metric-select"
                value={metric}
                className={`select ${dark ? "dk" : "lt"}`}
                label="METRIC TYPE"
                onChange={handleMetricChange}
              >
                <MenuItem selected={true} value={"location"}><Typography variant="caption">Location</Typography></MenuItem>
                <MenuItem value={"market"}><Typography variant="caption">Market</Typography></MenuItem>
              </Select>
            </FormControl>
            <FormControl variant="outlined" className="form-control" size="small">
              <InputLabel id={dark ? "otb-select" : "otb-select-lt"}>OTB CUSTOMERS</InputLabel>
              <Select
                name="otb"
                labelId="otb-select"
                value={filters.otb}
                className={`select ${dark ? "dk" : "lt"}`}
                label="OTB CUSTOMERS"
                onChange={handleFilterChange}
              >
                <MenuItem value={1}><Typography variant="caption">Include OTB Customers</Typography></MenuItem>
                <MenuItem value={0}><Typography variant="caption">Exclude OTB Customers</Typography></MenuItem>
              </Select>
            </FormControl>
            <FormControl variant="outlined" className="form-control" size="small">
              <InputLabel id={dark ? "trade-select" : "trade-select-lt"}>TRADE AREA</InputLabel>
              <Select
                name="trade"
                labelId="trade-select"
                value={filters.trade}
                className={`select ${dark ? "dk" : "lt"}`}
                label="TRADE AREA"
                onChange={handleFilterChange}
              >
                <MenuItem value={1}><Typography variant="caption">Include Customers Outside Trade Area</Typography></MenuItem>
                <MenuItem value={0}><Typography variant="caption">Exclude Customers Outside Trade Area</Typography></MenuItem>
              </Select>
            </FormControl>          
          </Paper>
          <Paper className={`table-border ${dark ? "bg-dk" : "bg-lt"}`}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center" colSpan={2} component="th" scope="row">
                    <Typography variant="caption" style={{fontWeight: "bold", color: `${dark ? "#fff" : "#6e6e6e"}`}}>COUNTS BY RFM SEGMENT</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell><Typography variant="caption" style={{fontSize: 11, fontWeight: "bold", color: `${dark ? "#fff" : "#6e6e6e"}`}}>RFM Segment</Typography></TableCell>
                  <TableCell align="right" style={{borderLeft: "1px solid #b3b3b3"}}><Typography variant="caption" style={{fontWeight: "bold", color: `${dark ? "#fff" : "#6e6e6e"}`}}>Counts</Typography></TableCell>
                </TableRow>
                {getSeries(rfmData).map(({name, color, data, order}) => (
                  <StyledTableRow key={order}>
                    <TableCell><Typography variant="caption" style={{color: `${color}`}}>{name}</Typography></TableCell>
                    <TableCell align="right" style={{borderLeft: "1px solid #b3b3b3"}}>
                      <Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{data.reduce((a,b) => a + b, 0).toLocaleString("en")}</Typography>
                    </TableCell>
                  </StyledTableRow>
                ))}
                <StyledTableRow>
                  <TableCell><Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`, fontWeight: "bold"}}>TOTAL</Typography></TableCell>
                  <TableCell align="right" style={{borderLeft: "1px solid #b3b3b3"}}><Typography variant="caption" style={{color: "#fff"}}>{getSeries(rfmData).map(({data}) => data.reduce((a,b) => a + b, 0)).reduce((a,b) => a + b, 0).toLocaleString("en")}</Typography></TableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </Paper>
          <Paper className={`grand-total ${dark ? "bg-dk" : "bg-lt"}`}>
            <Typography style={{color: `${dark ? "#fff" : "#6e6e6e"}`}} display="block" variant="caption">
              The <span style={{fontWeight: "bold"}}>Grand Total</span> RFM Count
              <div className="total">{rfmTotal ? rfmTotal.toLocaleString("en") : null}</div>
            </Typography>
          </Paper>
        </div>
      </div>
    </div>
  )
}

export default RfmCounts